import React from 'react';
import { connect } from 'react-redux';

import LoaderBlock from '@components/loaderBlock/LoaderBlock.tsx';
import getFormatedDate from '@functions/getFormatedDate.ts';
import { s } from '@functions/seo.ts';
import setSpacesInText from '@functions/setSpacesInText.ts';
import { StoreT } from '@global/types.ts';

import getArticle from './methods/getArticle.ts';
import setHeight from './methods/setHeight.ts';

import LegalInnerI from './types.ts';

class LegalInner
    extends React.Component<LegalInnerI['props'], LegalInnerI['state']>
    implements LegalInnerI
{
    parent: LegalInnerI['parent'];

    constructor(props: LegalInnerI['props']) {
        super(props);
        this.state = {
            article: s() ? this.props.seoData?.mainArticle : undefined,
        };

        this.parent = React.createRef();
    }

    getArticle = getArticle;

    setHeight = setHeight;

    componentDidMount() {
        this.getArticle();
    }

    render() {
        const { article, contentHeight } = this.state;

        return (
            <>
                <div ref={this.parent} className="publicLegalHeader__pageWrapper">
                    <LoaderBlock
                        loaderClassName="_main"
                        className="publicLegalHeader__pageLoader"
                        isShow={!article}
                    />
                    <div
                        className={`publicLegalHeader__pageBox ${article ? '_ready' : ''}`}
                        style={contentHeight ? { height: `${contentHeight}px` } : {}}
                    >
                        <div className="publicLegalHeader__pageBoxInner">
                            {article && (
                                <>
                                    <div className="publicLegalHeader__pageHead">
                                        <h1
                                            className="publicLegalHeader__pageTitle"
                                            dangerouslySetInnerHTML={{
                                                __html: setSpacesInText(article.title),
                                            }}
                                        ></h1>
                                        <div className="publicLegalHeader__pageDescription">
                                            <span>Дата публикации:</span>{' '}
                                            {getFormatedDate({
                                                date: new Date(article.createdDate),
                                                type: 'yearText',
                                            })}
                                        </div>
                                    </div>
                                    <div
                                        className="publicLegalHeader__pageContent"
                                        dangerouslySetInnerHTML={{
                                            __html: setSpacesInText(article?.content),
                                        }}
                                    ></div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(LegalInner);
